export default "__VITE_ASSET__CTB_Xr56__"